import React, { FC, useMemo } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { MultiSelect, MultiSelectPropertiesInterface } from '@affstore-ds/uikit'

import { localesEntity } from '../../entities/constants/localesEntity'
import { localesEntityTranslationKeys } from '../../entities/constants/localesEntity/translations/localesEntity.translationKeys'
import { commonTranslationKeys } from '../../shared/translations/common.translationKeys'
import { selectTranslationKeys } from '../../shared/translations/select.translationKeys'

export const LocalesMultiSelect: FC<Omit<MultiSelectPropertiesInterface, 'data'>> = ({ label, ...rest }) => {
  const { i18n } = useI18n()

  const LOCALE_LIST_PREPARED = useMemo(
    () =>
      localesEntity.LOCALE_LIST.map((item) => ({
        'data-testid': `locale-item-${item.value}`,
        label: i18n.t(item.translationKey),
        value: item.value,
      })).sort((a, b) => a.label.localeCompare(b.label)),
    // TODO: TASK-https://mbt.tpondemand.com/entity/394716-be-sort-locales-correctly
    [i18n],
  )

  return (
    <MultiSelect
      data-testid="locale-multi-select"
      label={label || i18n.t(localesEntityTranslationKeys.language)}
      bottomSheetTitle={label || i18n.t(localesEntityTranslationKeys.language)}
      clearLabel={i18n.t(selectTranslationKeys.selectClear)}
      data={LOCALE_LIST_PREPARED}
      emptySearchLabel={i18n.t(commonTranslationKeys.commonNoData)}
      maxDropdownHeight={400}
      placeholder={i18n.t(localesEntityTranslationKeys.allLocalesPlaceholder)}
      position="bottom"
      selectAllLabel={i18n.t(selectTranslationKeys.selectSelectAll)}
      variant="responsive"
      {...rest}
    />
  )
}
